/** Walk an AST and collect every field-reference name (unique, in first-seen
 *  order). Dotted refs (e.g. `items.amount`, `const.RATE`, `transaction.state`)
 *  are returned whole — the caller decides how to categorize a head. Literals,
 *  operators, and function names are ignored. Shared by the dry-run tester
 *  (scaffolds an input per ref) and any static dependency analysis. */
export function collectFieldRefs(ast) {
    const seen = new Set();
    walk(ast, seen);
    return [...seen];
}
function walk(node, out) {
    switch (node.type) {
        case "literal":
            return;
        case "fieldRef":
            out.add(node.name);
            return;
        case "binaryOp":
            walk(node.left, out);
            walk(node.right, out);
            return;
        case "unaryOp":
            walk(node.operand, out);
            return;
        case "functionCall":
            for (const arg of node.args)
                walk(arg, out);
            return;
    }
}
//# sourceMappingURL=collect-refs.js.map